/**
 * @file
 * GilderLehrman Theme Shared Functions.
 */

/**
 * Touch and click listening function
 * Original code from {@link http://output.jsbin.com/ijizat/25}
 *
 * @param {string} sel - A jQuery selector
 * @param {function} once - Function to run once
 * @param {function} fnc - Function to run upon touch or click
 *
 * @example
 *
 *  touchClick("#id-click", function() {
 *    $("#id-affected").toggleClass('new-class');
 *   });
 */
const touchClick = (sel, once, fnc) => {
  jQuery(once(sel, sel))
    .on("touchstart click", (event) => {
      /*
       * Propagation allows the tooltip to clear when clicking.
       * event.stopPropagation();
       */
      event.preventDefault();
      if (event.handled !== true) {
        fnc(event);
        event.handled = true;
      } else {
        return false;
      }
    });
};

export default touchClick;
